module.exports = __webpack_public_path__ + "media/images/mobile/solutions/28-711122f4c3c014fc06e1a837b2eacddf.png";